// Board-selection helpers shared by the profile tabs.
//
// The header switcher is MULTI-select, so tabs receive `examStreams` — an array
// of neetjee.exam ids — instead of a single value. The backend unions them and
// expands each to its group (EAMCET MPC = 3,6), so a tab only has to forward the
// array as-is.

// The GraphQL variable value. Null when nothing is selected, so the resolver
// treats it as "no board filter" rather than building an empty IN () list.
export const examStreamsVar = (streams) => {
    const ids = (Array.isArray(streams) ? streams : [])
        .map(Number)
        .filter((n) => Number.isInteger(n) && n > 0);
    return ids.length ? ids : null;
};

// The `exam_keys` variable: the selected option keys from getStudentExamStreams
// ("q" = Quick Exam, "2:1:r" = JEE Mains regular papers). Board ids alone can't
// separate Quick Exams or Mains/Advanced, so the backend narrows by these too.
export const examKeysVar = (keys) => (Array.isArray(keys) && keys.length ? keys.map(String) : null);

// Stable identity for componentDidUpdate. The prop is an array, so comparing it
// with !== would refetch on every re-render of the parent.
export const examStreamsKey = (streams) =>
    (Array.isArray(streams) ? streams : []).join(',');
